var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReceiptRefund = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.15 5A2.85 2.85 0 0 1 6 2.15h12A2.85 2.85 0 0 1 20.85 5v16a.85.85 0 0 1-1.23.76L16 19.95l-3.62 1.81a.85.85 0 0 1-.76 0L8 19.95l-3.62 1.81A.85.85 0 0 1 3.15 21zM6 3.85A1.15 1.15 0 0 0 4.85 5v14.625l2.77-1.385a.85.85 0 0 1 .76 0L12 20.05l3.62-1.81a.85.85 0 0 1 .76 0l2.77 1.385V5A1.15 1.15 0 0 0 18 3.85zm5.601 2.549a.85.85 0 0 1 0 1.202L10.052 9.15H12A4.85 4.85 0 0 1 16.85 14v1a.85.85 0 1 1-1.7 0v-1A3.15 3.15 0 0 0 12 10.85h-1.948l1.55 1.549a.85.85 0 0 1-1.203 1.202l-3-3a.85.85 0 0 1 0-1.202l3-3a.85.85 0 0 1 1.202 0",
  clipRule: "evenodd"
})));
export default SvgReceiptRefund;